/**
 * ヘッダーの高さを取得する
 * @returns {number}
 */
const getHeaderHeight = () => {
  const headerElement = document.getElementById('js-header');
  if (headerElement) {
    return headerElement.offsetHeight;
  }
  const cssVar = getComputedStyle(document.documentElement).getPropertyValue(
    '--js-height__header',
  );
  if (cssVar) {
    return parseInt(cssVar, 10);
  }
  return 0;
};

/**
 * ヘッダーの高さを考慮して要素までスクロールする
 * @param {Element} element
 */
const scrollToElement = (element) => {
  const headerHeight = getHeaderHeight();
  const elementPosition = element.getBoundingClientRect().top;
  const offsetPosition =
    elementPosition + window.pageYOffset - headerHeight;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
};

/**
 * ハッシュIDで指定された要素までスクロールし、URLを更新する
 * ドロワー閉じ後など、他モジュールから呼び出す用
 * @param {string} targetId - 例: "#contact"
 */
const scrollToElementById = (targetId) => {
  if (!targetId || targetId === '#') return;
  const targetElement = document.querySelector(targetId);
  if (targetElement) {
    scrollToElement(targetElement);
    window.history.pushState(null, '', targetId);
  }
};

/**
 * 遅延スクロール機能
 * 遅延処理でレイアウト安定化を待つ
 */
const delayedScroll = () => {
  // href属性に"#"が含まれるすべての<a>要素を取得
  document.querySelectorAll('a[href*="#"]').forEach((anchor) => {
    anchor.addEventListener('click', (event) => {
      const href = anchor.getAttribute('href');
      const hashIndex = href.indexOf('#');
      if (hashIndex === -1) return;

      const targetId = href.substring(hashIndex);
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        event.preventDefault();
        setTimeout(() => {
          scrollToElement(targetElement);
          window.history.pushState(null, '', targetId);
        }, 50);
      }
    });
  });

  /**
   * ページ読み込み時のハッシュ処理
   */
  const handleInitialHash = () => {
    const hash = window.location.hash;
    if (hash && hash !== '#') {
      const targetElement = document.querySelector(hash);
      if (targetElement) {
        setTimeout(() => {
          scrollToElement(targetElement);
        }, 200);
      }
    }
  };

  // ページ読み込み完了後にハッシュ処理を実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleInitialHash);
  } else {
    handleInitialHash();
  }
};

export { delayedScroll, scrollToElementById };
